import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { OutletService } from './outlet.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatDatepickerModule } from '@angular/material';
import { OutletListComponent } from './list/list.component';
import { OutletFormComponent } from './form/form.component';

import { OutletListGuard } from './outlet-list.guard';
import { OutletGuard } from './outlet.guard';
import { TooltipModule } from 'ngx-bootstrap';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatInputModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  declarations: [
    OutletListComponent,
    OutletFormComponent,
    // KeysPipe,
  ],
  exports: [
  ]
})
export class OutletModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: OutletModule,
      providers: [
        OutletService,
        OutletListGuard,
        OutletGuard,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/outlet/outlet.module.ts